import { Project } from '../../project/Project';

// TODO : À remplacer lors du merge avec multi étage
export const migrateProject35To36 = (project: Project): Project => project;
